import { salvarPlanoNaSessao } from './planos'

// Navegação de unidade compartilhada (usada pela tela de Visão geral do pool).
// Espelha a lógica de getPlace/getUser/goToPlace (else-branch) de TableSideBarList.jsx,
// que continua a alimentar o picker do admin. enterUnit NÃO mexe em pool_secret.

// ── Módulos liberados por unidade ────────────────────────────────────────────
// O painel (Configurações do robô → Plano e status) marca quais módulos a
// unidade enxerga. As abas leem isso do localStorage, junto das outras chaves
// de unidade, então todo lugar que "entra numa unidade" tem que gravá-las.

// AUSENTE no banco ≠ desmarcado: significa que a caixa nunca foi tocada. Nesse
// caso vale a regra antiga — o Financeiro era liberado por pdv === 'allegro_auto'
// — para nenhuma unidade em produção perder a aba no dia do deploy.
export function financeModuleOf(place) {
    if (place.module_finance === true || place.module_finance === false) return place.module_finance
    return place.pdv === 'allegro_auto'
}

export function setPlaceModules(place) {
    localStorage.setItem("mod_fin", String(financeModuleOf(place)))
    localStorage.setItem("mod_del", String(place.module_delivery === true))
}

// ── Integrações que entregam os dados sozinhas ───────────────────────────────
// Duas coisas as separam das importações manuais, e as duas mudam o que as
// telas podem assumir: a base é atualizada DURANTE o mês (import parcial) e o
// tracking traz visit_dates com as datas reais de cada visita.
//
// Hoje: Allegro automático (programa no PC da loja) e PlayLave (nuvem). Quem
// precisar distinguir tem que perguntar AQUI — foi espalhar
// `pdv === 'allegro_auto'` pelas telas que fez o PlayLave nascer com o B.I.
// contando o mês em andamento e a conversão divergindo do backend.
export function hasAutoIntegration() {
    const pdv = localStorage.getItem('pdv')
    return pdv === 'allegro_auto' || pdv === 'playlave_auto'
}

export async function getPlace(userId) {
    const BASE_URL = process.env.REACT_APP_BASE_URL
    let response = null
    await fetch(BASE_URL + '/places/' + userId, {
        method: 'GET',
        headers: new Headers({
            'Authorization': 'Bearer ' + localStorage.getItem("nekb")
        })
    })
        .then(res => res.json())
        .then(data => { response = data })
        .catch(rejected => { console.log(rejected) })
    return response
}

export async function getUser(userId) {
    const BASE_URL = process.env.REACT_APP_BASE_URL
    let response = null
    await fetch(BASE_URL + '/user/' + userId, {
        method: 'GET',
        headers: new Headers({
            'Authorization': 'Bearer ' + localStorage.getItem("nekb")
        })
    })
        .then(res => res.json())
        .then(data => { response = data })
        .catch(rejected => { console.log(rejected) })
    return response
}

// Quando um usuário pool entra numa unidade, registra como "último login" daquela unidade
// (mesma lógica do /auth/login para usuários normais). Só roda para pool.
export async function maybeRecordPoolUnitLogin(userId) {
    if (localStorage.getItem("pool_secret") !== POOL_SECRET) return
    const BASE_URL = process.env.REACT_APP_BASE_URL
    try {
        await fetch(BASE_URL + '/user/login-tracker/' + userId, {
            method: 'POST',
            headers: new Headers({ 'Authorization': 'Bearer ' + localStorage.getItem("nekb") })
        })
    } catch (e) {
        console.log(e)
    }
}

// Entra numa unidade: reescreve as chaves de unidade no localStorage e recarrega em "/".
// Mantém pool_secret (a sessão continua sendo um pool).
// destino (opcional): outra aba da unidade para abrir direto (ex.: '/developers',
// usado pelo radar do Developers admin). Padrão "/", como sempre foi.
export async function enterUnit(place, user, destino = '/') {
    await maybeRecordPoolUnitLogin(user._id)

    localStorage.setItem("resd", user._id)
    localStorage.setItem("username", user.username)

    localStorage.setItem("tabPath", "home")
    localStorage.setItem("viewType", "user")
    localStorage.setItem("nim", place.camp_miss_you_min_days)
    localStorage.setItem("xam", place.camp_miss_you_max_days)
    localStorage.setItem("act", place.camp_active_days)
    localStorage.setItem("pdv", place.pdv)
    setPlaceModules(place)
    localStorage.setItem("ddd", String(place.phone || '').slice(3, 5))
    localStorage.setItem("place_name", place.name)
    localStorage.setItem("camp", "")

    // plano (códigos novos e antigos) → nalp + direitos da sessão (./planos)
    salvarPlanoNaSessao(place)

    localStorage.setItem("TAG", place.import_data_tag)

    localStorage.setItem("plusCamp3", 0)

    window.location.href = destino
}

// Volta para a Visão geral do pool: reseta o viewType e limpa as chaves de unidade,
// mantendo pool_secret + places.
export function backToPoolOverview() {
    localStorage.setItem("viewType", "pool")
    localStorage.setItem("tabPath", "overview")
    localStorage.removeItem("nim")
    localStorage.removeItem("xam")
    localStorage.removeItem("act")
    localStorage.removeItem("pdv")
    localStorage.removeItem("mod_fin")
    localStorage.removeItem("mod_del")
    localStorage.removeItem("mod_not")
    localStorage.removeItem("ddd")
    localStorage.removeItem("place_name")
    localStorage.removeItem("camp")
    localStorage.removeItem("nalp")
    localStorage.removeItem("dir")
    localStorage.removeItem("TAG")
    localStorage.removeItem("plusCamp3")
    localStorage.removeItem("jumpClients")
    window.location.href = "/overview"
}

export const POOL_SECRET = "POOL_VL"
